import apiUrl from '../../../constants'
import axios from 'axios'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
import SimpleEncrypt from 'simple-encryptor'
import common_helper from '../../../common_helper'

export default {
	name: 'orderdetailsAccordian',
	components: {
		VueElementLoading
	},
	props: ['selectedRow', 'filterData','shipwmntwise'],
	data() {
		return {
			shipwmntwise: this.shipwmntwise,
			shipmentid:this.selectedRow.shipmentcount,
			pono: this.selectedRow.orderid || this.selectedRow.poid,
			urlclientid: this.filterData.clientid,
			urlwarehouseid: this.filterData.warehouseid,
			shipByDate: "",
			isLoading: false,
			// initialize form field
			listOrderMasterdata: [],
			listOrderDetailsData: [],
			shipmentDetailsStatus: [],
			shipMasterData: [],
			getdata: [],
			listShippingDetailsData: [],
			poid: '',
			pagenoship: 0,
			pagecountship: 0,
			pagenoorder: 0,
			pagecountorder: 0,
			shipmentDetailsCount: 0,
			ordermaster: {},
			orderDetails: [],
			clientdata: {},
			invoicemodal: false,
			orderModifyDetails: [],

			loginwarehouseid: 0,
			totalitems: '',
			totalorderqty: 0,
			totalamount: 0,
			shippingdata: [],
			shippinginvoicedata: [],
			shippinginvoicedatacal: [],
			clientdata: [],
			shippingcharges: 0,
			invoiceheadername: '',
			// pono: '',
			invoicephname: '',
			// urlclientid: '',
			// urlwarehouseid: '',
			clientDetails: {},
			allocatedRacks: [],
			pickedOrderLogDetail: [],
			nfOrderLogDetail: [],
			qcpackingDetails: [],
			packingDetails: [],
			cancelputawayDetails: [],
			splitboxDetails:[],
			splittedboxDetails:[],
			orderDetailsCount: 0,
			pickedLogCount: 0,
			nfLogCount: 0,
			packingQCDetails: 0,
			shipcount: 0,
			packingCount: 0,
			returnsCreationCount: 0,
			cancelputawayCount: 0,
			returnLogsOrderDetails:[],
			returnsPutAwayDetails:[],
			returnsLogsWarehouseInscanDetails:[],
			returnUniqueWarehouseInscanDetails:{},
			splitboxCount:0,
			splittedboxCount:0,
			expanded: false,
			accordianTab: {
				1: false,
				2: false,
				3: false,
				4: false,
				5: false,
				6: false,
				7: false,
				8: false
			},
			consoBinPickedLogDetail: [],
			consoBinPickedLogCount: 0,
			consoPutawayLogDetail: [],
			consoPutawayLogCount: 0,
			returnsPutAwayCount:0,
			consoTotePickedLogDetail: [],
			consoTotePickedLogCount: 0,
			custAddress: ''
		}
	},
	created: function () {

	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},
	computed: {
		discount: function () {
			return this.listOrderDetailsData.reduce(function (discount, item) {
				return discount + item.discount;
			}, 0);
		},

	},
	mounted() {

		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		// this.loginwarehouseid = userdetail.warehouseid;
		// this.loginClientUserId = userdetail.clientid;

		this.getReturnDetails();
		this.getorderDetails();
		this.getOutQCDetails();
		this.getshippingData();
		this.getOrderItemDetails();
		this.getPickingDetails();
		this.getPackingDetails();
		this.getConsolidationDetails();
		this.getCancelPutaway();
		this.data();
		this.pagenoship = 0
		this.pagenoorder = 0
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		data() {
			this.getdata.push(this.backtoparent)
		},

		async getConsolidationDetails() {
			this.isLoading = true;
			this.input = ({
				orderid: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid
			});
			let result = await common_helper.getRestApiResponse('POST', 'consolidationOrderDetails', this.input)
			if (result && !result.errorDATA) {
				if (result.data.data.ErrorCode == 0) {
					this.consoBinPickedLogDetail = result.data.data.data.resultBinPickingDetails
					this.consoBinPickedLogCount = result.data.data.data.resultBinPickingDetails.length
					this.consoPutawayLogDetail = result.data.data.data.resultTotePickingDetails
					this.consoPutawayLogCount = result.data.data.data.resultTotePickingDetails.length
					this.consoTotePickedLogDetail = result.data.data.data.resultToteClientMap
					this.consoTotePickedLogCount = result.data.data.data.resultToteClientMap.length
				} else {
					this.consoBinPickedLogDetail = []
					this.consoBinPickedLogCount = 0
					this.consoPutawayLogDetail = []
					this.consoPutawayLogCount = 0
					this.consoTotePickedLogDetail = []
					this.consoTotePickedLogCount = 0
				}
				this.isLoading = false;
			}
		},
		encryptData(encData) {
			return this.encryptor.encrypt(encData);
		},
		decryptData(decData) {
			return this.encryptor.decrypt(decData);
		},
		expandAll() {
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll() {
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid) {
			for (var key in this.accordianTab) {
				if (tabid != key) {
					this.accordianTab[key] = false;
				}
			}
		},
		getScore(val) {
			if (!val) {
				return 0.00
			}
			return Number(val).toFixed(2);
		},
		valueFormatter(value){
           if(value===null){
			return "-"
		   }else{
			return value 
		   }
		},
		setProductid(data){
          if(data.status == "WHInscan" || data.status=="whreceived"){
			return data.inscanproductid
		  }
		  else{
			return data.productid
		  }
		},
		setEancode(data){
			if(data.status == "WHInscan" || data.status=="whreceived"){
				return data.inscaneancode
			  }
			  else{
				return data.eancode
			}
		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		rejectReason(reason) {
			if (reason === null) {
				return '';
			} else if (reason == "") {
				return "--";
			} else {
				if (reason.length == 0) {
					return '';
				} else {
					return reason.join();
				}
			}

		},
		toUpper(str) {
			if (str !== null && str !== undefined) {
				return str.charAt(0).toUpperCase() + str.slice(1);
			} else {
				return '--'
			}

		},
		async getorderDetails() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "orderDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null
			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {

				this.listOrderMasterdata = result.data.data.orderMaster[0];
				if ((result.data.data.orderMaster[0].custaddress1 != null || result.data.data.orderMaster[0].custaddress1 != '') && (result.data.data.orderMaster[0].custaddress2 == null || result.data.data.orderMaster[0].custaddress2 == null)) {
					this.custAddress = result.data.data.orderMaster[0].custaddress1;
				} else if ((result.data.data.orderMaster[0].custaddress1 == null || result.data.data.orderMaster[0].custaddress1 == '') && (result.data.data.orderMaster[0].custaddress2 != null || result.data.data.orderMaster[0].custaddress2 != '')) {
					this.custAddress = result.data.data.orderMaster[0].custaddress2;
				} else {
					this.custAddress = result.data.data.orderMaster[0].custaddress1 + " " + result.data.data.orderMaster[0].custaddress2;
				}

				this.orderDetailsCount = this.listOrderMasterdata.length;
				this.isLoading = false;
				this.shipByDate = ''
				this.input = {
					pono: this.pono,
					clientid: this.urlclientid,
					warehouseid: this.urlwarehouseid,
					shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

				}
				let getShipData = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
				if (getShipData && !getShipData.errorDATA) {
					if (getShipData.data.data.errorCode == 0) {
						this.shipByDate = getShipData.data.data.data[0].shipbydate
					}

				}
			}
		},
		async getshippingData() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "ShippingDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {
				this.shipMasterData = result.data.data.shipping_data[0];
				this.shipcount = result.data.data.shipCount
				this.shipmentDetailsStatus = result.data.data.shipmentstatusDetails
				this.shipmentDetailsCount = Object.keys(this.shipmentDetailsStatus).length;
				this.listShippingDetailsData = result.data.data.shipping_data;
				this.shipMasterData = result.data.data.shipping_data[0];
				this.shipcount = result.data.data.shipCount
				let totalRows = result.data.data.shipCount;
				if (totalRows < 10) {
					this.pagecountship = 1
					this.pagecountorder = 1
				} else {
					this.pagecountship = Math.ceil(totalRows / 10)
				}
				this.isLoading = false;
			}
		},
		async getOrderItemDetails() {

			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "OrderItemDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {

				this.listOrderDetailsData = result.data.data.orderDetails;
				this.orderDetailsCount = this.listOrderDetailsData.length;
				this.orderModifyDetails = result.data.data.orderModifyDetails;
				var allocatedRack = result.data.data.allocatedRack;
				for (var j = 0; j < allocatedRack.length; j++) {

					if (this.allocatedRacks[allocatedRack[j].orderitemid] === undefined) {
						this.allocatedRacks[allocatedRack[j].orderitemid] = allocatedRack[j].rackid;
					} else {
						if (this.allocatedRacks[allocatedRack[j].orderitemid] != allocatedRack[j].rackid) {
							this.allocatedRacks[allocatedRack[j].orderitemid] += ',' + allocatedRack[j].rackid;
						}
					}
				}
				this.totalitems = this.listOrderDetailsData.length;
				for (var i = 0; i < this.totalitems; i++) {
					this.totalorderqty += Number(this.listOrderDetailsData[i].totalqty)
					this.totalamount += ((this.listOrderDetailsData[i].totalqty * this.listOrderDetailsData[i].mrp) - this.listOrderDetailsData[i].discount)
				}
				this.isLoading = false;
			}
		},
		async getPickingDetails() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "PickingDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {
				this.pickedOrderLogDetail = result.data.data.pickedOrderDetails;
				this.pickedLogCount = this.pickedOrderLogDetail.length;
				this.nfOrderLogDetail = result.data.data.nfDetail;
				this.nfLogCount = this.nfOrderLogDetail.length;
				this.isLoading = false;
			}
		},
		async getOutQCDetails() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "OutQCDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {
				this.qcpackingDetails = result.data.data.qcpackingDetails;
				this.packingQCDetails = this.qcpackingDetails.length;
				this.isLoading = false;
			}
		},
		async getPackingDetails() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "packingDetails",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {
				this.packingDetails = result.data.data.packingDetails;
				this.packingCount = this.packingDetails.length;
				this.splitboxDetails = result.data.data.splitDetails;
				this.splitboxCount = this.splitboxDetails.length;
				//this.splittedboxDetails = result.data.data.splittedBoxes;
				if(result.data.data.splitDetails.length>0)
                this.splittedboxDetails = result.data.data.splitDetails.filter(e=>{if(e.sourcebox!== e.destinationbox) return e}).map(e=>Number(e.destinationbox))
				this.isLoading = false;
			}
		},
		async getCancelPutaway() {
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "cancelputaway",
				shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result = await common_helper.getRestApiResponse('POST', 'getSingleOrderDetailsUpdatedForTab', this.input)
			if (result && !result.errorDATA) {
				this.cancelputawayDetails = result.data.data.cancelputawayDetails;
				this.cancelputawayCount = this.cancelputawayDetails.length;
				this.isLoading = false;
			}
		},
		async getReturnDetails(){
			this.isLoading=true;
			this.input=({
               pono:this.pono,
			   clientid:this.urlclientid,
			   warehouseid:this.urlwarehouseid,
			   type:"Returns",
			   shipmentid: (Number(this.shipwmntwise)==1 && this.shipmentid!='' && this.shipmentid!=null)?this.shipmentid:null

			});
			let result=await common_helper.getRestApiResponse('POST','getSingleOrderDetailsUpdatedForTab',this.input)
			if (result && !result.errorDATA){
				this.returnLogsOrderDetails = result.data.data.details 
				this.returnsCreationCount = this.returnLogsOrderDetails.length
				this.returnsPutAwayDetails = result.data.data.putawaydetails
				this.returnsPutAwayCount=this.returnsPutAwayDetails.length
				for(var i=0;i<this.returnLogsOrderDetails.length;i++){
                     if(!this.returnUniqueWarehouseInscanDetails[this.returnLogsOrderDetails[i].returnid]){
                         this.returnsLogsWarehouseInscanDetails.push(this.returnLogsOrderDetails[i])
						 this.returnUniqueWarehouseInscanDetails[this.returnLogsOrderDetails[i].returnid]=this.returnLogsOrderDetails[i]
					 }else{
						this.returnUniqueWarehouseInscanDetails[this.returnLogsOrderDetails[i].returnid]=this.returnLogsOrderDetails[i]
					 }
				}
				console.log(this.returnLogsOrderDetails);
				this.isLoading=false;
			}
		},

		createGoogleLink(imageLink, id) {
			var preURL = 'https://drive.google.com/uc?export=view&id=';
			var validUrl = '';
			var tempUrl = imageLink.split('?id=');
			if (tempUrl.length == 1) {
				var tempURL = imageLink.split('https://drive.google.com/file/d/');
				var tempURL1 = tempURL[1].split('/view');
				var validUrl = preURL + tempURL1[0];
				//this.productimage = validUrl;
				$("#" + id).attr("src", validUrl);
			} else {
				validUrl = preURL + tempUrl[1];
				$("#" + id).attr("src", validUrl);
			}

		},
		async getHandoverPDF(manifestid){
			try {
				const userToken = window.localStorage.getItem('userToken')
				const myStr = userToken.replace(/"/g, '');
				this.isLoading = true;
				this.input = ({
					clientid: this.urlclientid,
					manifestid: manifestid
				});
				const result = await axios({
					method: 'POST',
					'url': apiUrl.api_url + 'generatepdfImagesManifest',
					'data': this.input,
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + myStr
					}
				})
				if (result.data && result.data.status) {
					window.open(result.data.pdfUrl, "_blank");
				}else{
					this.$alertify.error(this.$t('manifestReport.noDocumentFound'))
				}
				this.isLoading = false;
			} catch (error) {
				this.isLoading = false;
				this.$alertify.error('Some Error Occured. Please Try Again.')				
				//this.$alertify.error(this.$t('apiErrors.SOME_ERR_OCCURED'))
				console.error(error)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailsAccordian/orderdetailsAccordian.component.js